import { useEffect, useState } from "react";
import { Button } from "react-bulma-components";
import { faDesktop } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ChannelConnection from "../../js/connection/ChannelConnection";
import { toast } from "bulma-toast";
import ConnectionData from "../../js/connection/ConnectionData";

type Props = {
    connection: ChannelConnection | undefined,
    onClick: React.MouseEventHandler<HTMLButtonElement> | undefined
};

export default function ScreenshareToggle({ connection, onClick }: Props) {
    const [presenter, setPresenter] = useState<ConnectionData | null>();

    useEffect(() => {
        function onScreenshareUpdate(connectionData: ConnectionData | null) : void {
            setPresenter(connectionData);
    
            if (connectionData) {
                toast({ message: `${connectionData.userAlias ?? "Someone"} has started a screen share.`, type: 'is-warning', position: 'top-center' });
            }
        }

        connection?.events.addListener("onscreenshareupdate", onScreenshareUpdate);

        return () => {
            connection?.events.removeListener("onscreenshareupdate", onScreenshareUpdate);
        }
    }, [connection]);

    function canScreenshare() : boolean {
        return !presenter || (presenter.roles && presenter.roles.includes("screenshare"));
    }

    function getScreenshareTooltip() : string {
        let tooltip: string = "Toggle screen sharing";
        if (!canScreenshare()) {
            tooltip = `${presenter?.userAlias ?? "Someone"} is currently sharing their screen`;
        }
        return tooltip;
    }

    function getScreenshareColor() : string {
        return !!presenter ? "warning" : "success";
    }
    
    return (
        <Button disabled={!canScreenshare()}
                color={getScreenshareColor()}
                rounded
                data-tooltip={getScreenshareTooltip()}
                onClick={onClick}>
            <FontAwesomeIcon icon={faDesktop} />
        </Button>
    );
}
